import { useMemo } from 'react';
import { MediaType } from '../../../../constants/MediaType';
import { useMMGRSettings } from '../../../../utils/hoc/withMMGRSettings';
import { MediaManagerSDKAnyUploadingFile } from '../../../../utils/media-manager-sdk';
import { getUploadingFileProps } from '../../../../utils/uploadingFile';
import { Document } from './Thumbnails/Document';
import { Empty } from './Thumbnails/Empty';
import { Folder } from './Thumbnails/Folder';
import { Music } from './Thumbnails/Music';
import { Picture } from './Thumbnails/Picture';
import { Video } from './Thumbnails/Video';
import { TSelectThumbnail } from './UploadingFileThumbnail.types';

const selectThumbnail: TSelectThumbnail = (mediaType) => {
  switch (mediaType) {
    case MediaType.Folder:
      return Folder;

    case MediaType.Picture:
    case MediaType.SecurePicture:
    case MediaType.VectorArt:
      return Picture;

    case MediaType.Video:
    case MediaType.SecureVideo:
      return Video;

    case MediaType.Document:
    case MediaType.SecureDocument:
      return Document;

    case MediaType.Music:
    case MediaType.SecureMusic:
      return Music;

    default:
      return Empty;
  }
};

export const useUploadingFileProps = (uploadingFile: MediaManagerSDKAnyUploadingFile) => {
  const { mmgrSettings } = useMMGRSettings();
  const { isSecureContext, privateMediaRestAPI } = mmgrSettings;

  return useMemo(() => {
    const { src, file, mediaType } = getUploadingFileProps({ uploadingFile, isSecureContext, privateMediaRestAPI });
    const Thumbnail = selectThumbnail(mediaType);

    return { src, file, mediaType, Thumbnail };
  }, [uploadingFile, isSecureContext, privateMediaRestAPI]);
};
